import Vue from 'vue'
import Router from 'vue-router'

import IndexPortale from '@/components/IndexPortale'

import IndexRottame from '@/components/Rottame/IndexRottame'
import GestioneRottame from '@/components/Rottame/WebGestioneRottame/GestioneRottame'
import Conferme from '@/components/Rottame/WebGestioneRottame/Conferme'
import ElencoBuoniRottame from '@/components/Rottame/WebGestioneRottame/ElencoBuoni'
import DettaglioBuonoRottame from '@/components/Rottame/WebGestioneRottame/DettaglioBuono'
import StoricoRottame from '@/components/Rottame/WebStoricoRottame/StoricoRottame'
import ElencoBuoniStoricoRottame from '@/components/Rottame/WebStoricoRottame/ElencoBuoni'
import GestioneTrattativa from '@/components/Rottame/WebGestioneTrattativa/GestioneTrattativa'
import ElencoTrattative from '@/components/Rottame/WebGestioneTrattativa/ElencoTrattative'
import DettaglioTrattativa from '@/components/Rottame/WebGestioneTrattativa/DettaglioTrattativa'

import IndexFornitura from '@/components/Fornitura/IndexFornitura'
import RichiesteDiOfferta from '@/components/Fornitura/RichiesteDiOfferta/RichiesteDiOfferta'
import Offerte from '@/components/Fornitura/RichiesteDiOfferta/Offerte'
import DettaglioOfferta from '@/components/Fornitura/RichiesteDiOfferta/DettaglioOfferta'
import SituazioneOrdini from '@/components/Fornitura/SituazioneOrdini/SituazioneOrdini'
import Ordini from '@/components/Fornitura/SituazioneOrdini/Ordini'
import DettaglioOrdine from '@/components/Fornitura/SituazioneOrdini/DettaglioOrdine'
import NuovoBuono from '@/components/Fornitura/SituazioneOrdini/NuovoBuono'
import RichiesteDiQuotazione from '@/components/Fornitura/RichiesteDiQuotazione/RichiesteDiQuotazione'
import Quotazioni from '@/components/Fornitura/RichiesteDiQuotazione/Quotazioni'
import DettaglioQuotazione from '@/components/Fornitura/RichiesteDiQuotazione/DettaglioQuotazione'

import IndexAccessoStabilimenti from '@/components/AccessoStabilimenti/IndexAccessoStabilimenti'
import AnagraficaDipendenti from '@/components/AccessoStabilimenti/GestioneAppalti/AnagraficaDipendenti/AnagraficaDipendenti'
import Dipendenti from '@/components/AccessoStabilimenti/GestioneAppalti/AnagraficaDipendenti/Dipendenti'
import DettaglioDipendente from '@/components/AccessoStabilimenti/GestioneAppalti/AnagraficaDipendenti/DettaglioDipendente'
import DocumentiRichiesti from '@/components/AccessoStabilimenti/GestioneAppalti/DocumentiRichiesti/DocumentiRichiesti'
import ElencoDocumenti from '@/components/AccessoStabilimenti/GestioneAppalti/DocumentiRichiesti/ElencoDocumenti'
import Documento from '@/components/AccessoStabilimenti/GestioneAppalti/Documento'
import AssociaDipendenti from '@/components/AccessoStabilimenti/GestioneAppalti/AssociaDipendenti/AssociaDipendenti'
import ElencoOrdini from '@/components/AccessoStabilimenti/GestioneAppalti/AssociaDipendenti/ElencoOrdini'
import Contestazioni from '@/components/AccessoStabilimenti/GestioneAppalti/Contestazioni/Contestazioni'
import ElencoContestazioni from '@/components/AccessoStabilimenti/GestioneAppalti/Contestazioni/ElencoContestazioni'
import DettaglioContestazione from '@/components/AccessoStabilimenti/GestioneAppalti/Contestazioni/DettaglioContestazione'

// --Login
import IndexLogin from '@/components/Login/Index'
import Login from '@/components/Login/Login'
import Registrazione from '@/components/Login/Registrazione'
import Recovery from '@/components/Login/Recovery'
import Support from '@/components/Login/Support'
import DocumentiGenerici from '@/components/Login/DocumentiGenerici'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IndexPortale',
      component: IndexPortale,
      children: [
        {
          path: 'accessostabilimenti',
          name: 'ACCSTA',
          component: IndexAccessoStabilimenti,
          meta: {
            area: 'ACCSTA'
          },
          children: [
            {
              path: 'anagraficadipendenti',
              name: 'AnagraficaDipendenti',
              component: AnagraficaDipendenti,
              meta: {
                appName: 'WebAnagraficaDip'
              },
              children: [
                {
                  path: 'dipendenti',
                  name: 'DIPDipendenti',
                  component: Dipendenti
                },
                {
                  path: 'dipendente',
                  name: 'DIPDipendente',
                  component: DettaglioDipendente
                },
                {
                  path: 'documento/:id?',
                  name: 'DIPDocumento',
                  component: Documento
                }
              ]
            },
            {
              path: 'documentirichiesti',
              name: 'DocumentiRichiesti',
              component: DocumentiRichiesti,
              meta: {
                appName: 'WebDocRichiesti'
              },
              children: [
                {
                  path: 'elenco',
                  name: 'DOCElenco',
                  component: ElencoDocumenti
                },
                {
                  path: 'documento/:id?',
                  name: 'DOCDocumento',
                  component: Documento
                }
              ]
            },
            {
              path: 'associadipendenti',
              name: 'AssociaDipendenti',
              component: AssociaDipendenti,
              meta: {
                appName: 'WebAssociaDip'
              },
              children: [
                {
                  path: 'ordini',
                  name: 'ASSOrdini',
                  component: ElencoOrdini
                }
              ]
            },
            {
              path: 'contestazioni',
              name: 'Contestazioni',
              component: Contestazioni,
              meta: {
                appName: 'WebContestazioni'
              },
              children: [
                {
                  path: 'elenco',
                  name: 'CONElenco',
                  component: ElencoContestazioni
                },
                {
                  path: 'contestazione',
                  name: 'CONDettaglioContestazione',
                  component: DettaglioContestazione
                }
              ]
            }
          ]
        },
        {
          path: 'fornitura',
          name: 'UFFACQ',
          component: IndexFornitura,
          meta: {
            area: 'UFFACQ'
          },
          children: [
            {
              path: 'buonidiritiro',
              name: 'BuoniDiRitiro',
              component: SituazioneOrdini,
              meta: {
                appName: 'WebBuoniDiRitiro'
              },
              props: {
                appName: 'WebBuoniDiRitiro'
              },
              children: [
                {
                  path: 'ordini',
                  name: 'BdROrdini',
                  component: Ordini
                },
                {
                  path: 'dettaglio',
                  name: 'BdRDettaglioOrdine',
                  component: DettaglioOrdine
                },
                {
                  path: 'nuovo',
                  name: 'BdRNuovoBuono',
                  component: NuovoBuono
                }
              ]
            },
            {
              path: 'situazioneordini',
              name: 'SituazioneOrdini',
              component: SituazioneOrdini,
              meta: {
                appName: 'SituazioneOrdini'
              },
              props: {
                appName: 'SituazioneOrdini'
              },
              children: [
                {
                  path: 'ordini',
                  name: 'SOOrdini',
                  component: Ordini
                },
                {
                  path: 'dettaglio',
                  name: 'SODettaglioOrdine',
                  component: DettaglioOrdine
                },
                {
                  path: 'nuovo',
                  name: 'SONuovoBuono',
                  component: NuovoBuono
                }
              ]
            },
            {
              path: 'richiestediofferta',
              name: 'RichiesteDiOfferta',
              component: RichiesteDiOfferta,
              meta: {
                appName: 'WebRichiestaOfferta'
              },
              children: [
                {
                  path: 'offerte',
                  name: 'RdOOfferte',
                  component: Offerte
                },
                {
                  path: 'dettaglio',
                  name: 'RdODettaglioOfferta',
                  component: DettaglioOfferta
                }
              ]
            },
            {
              path: 'richiestediquotazione',
              name: 'RichiesteDiQuotazione',
              component: RichiesteDiQuotazione,
              meta: {
                appName: 'WebRichiesteQuot'
              },
              children: [
                {
                  path: 'quotazioni',
                  name: 'RdQQuotazioni',
                  component: Quotazioni
                },
                {
                  path: 'quotazione',
                  name: 'RdQDettaglioQuotazione',
                  component: DettaglioQuotazione
                }
              ]
            }
          ]
        },
        {
          path: 'rottame',
          name: 'TRAACQ',
          component: IndexRottame,
          meta: {
            area: 'TRAACQ'
          },
          children: [
            {
              path: 'gestionerottame',
              name: 'GestioneRottame',
              component: GestioneRottame,
              meta: {
                appName: 'WebGestioneRottame'
              },
              children: [
                {
                  path: 'conferme',
                  name: 'GestioneRottameConferme',
                  component: Conferme
                },
                {
                  path: 'buoni',
                  name: 'GestioneRottameElencoBuoni',
                  component: ElencoBuoniRottame
                },
                {
                  path: 'dettaglio',
                  name: 'GestioneRottameDettaglio',
                  component: DettaglioBuonoRottame
                }
              ]
            },
            {
              path: 'storicorottame',
              name: 'StoricoRottame',
              component: StoricoRottame,
              meta: {
                appName: 'WebStoricoRottame'
              },
              children: [
                {
                  path: 'buoni',
                  name: 'StoricoRottameBuoni',
                  component: ElencoBuoniStoricoRottame
                }
              ]
            },
            {
              path: 'gestionetrattativa',
              name: 'GestioneTrattativa',
              component: GestioneTrattativa,
              meta: {
                appName: 'WebTrattativaRottame'
              },
              children: [
                {
                  path: 'trattative',
                  name: 'ElencoTrattative',
                  component: ElencoTrattative
                },
                {
                  path: 'trattativa',
                  name: 'DettaglioTrattativa',
                  component: DettaglioTrattativa
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      component: IndexLogin,
      children: [
        {
          path: '',
          name: 'Login',
          component: Login
        },
        {
          path: 'registrazione',
          name: 'Registrazione',
          component: Registrazione
        },
        {
          path: 'recovery',
          name: 'Recovery',
          component: Recovery
        },
        {
          path: 'support',
          name: 'Support',
          component: Support
        },
        {
          path: 'documentigenerici',
          name: 'DocumentiGenerici',
          component: DocumentiGenerici
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js